import React, { useState } from "react";
import Table from "common/graphs/Table/Table";
import { atoiv6, atoiv4 } from "common/utils";

const doesNothing = () => {};

const notDeleted = ({ deleted }) => deleted !== true;

export const classForType = (type) => (type === "number" ? "text-right" : "");

const getColumns = (fields, onEdit, onDelete) => {
  const mainFields = fields.map(({ name, label, type, colHeadClass, renderCell })=> {

    return {
      label: label.toUpperCase(),
      id: name,
      numeric: type === "number",
      ...(type === "days" ? { renderCell:  (value)=> renderCell(value, "edit")} : {}),
      ...(name === "direction" ? { renderCell:  (value) => {
        if (value === "any") {
          return "uplink or downlink"
        }
        return value;
      }} : {}),
      parse: (value) => {
        if (name=== "address") {
          if(!value){
            return 0;
          }
          const [addr, port] = value.split("/");
          return addr.includes(":") ? atoiv6(addr) : atoiv4(addr);
        }
        if (name === "port"){
          return value === "any" ? 0: parseFloat(value);
        }
        if (type==="number"){
          return parseFloat(value);
        }
        return value;
      },
      parseFilter: (value) => value        
  }});
  return [...mainFields, {
    label: "ACTIONS",
    id: "ACTIONS",
    actions: [
      {
        label: "Edit",
        icon: "edit",
        onClick: (row) => onEdit(row["__id"]),
      },
      {
        label: "Delete",
        icon: "delete",
        onClick: (row) => onDelete([row["__id"]]),
      },
    ],
  }];
}

const ListItems = ({
  className = "",
  items = [],
  fields = [],
  onDelete = doesNothing,
  onEdit = doesNothing,
}) => {
  const [selected, setSelected] = useState([]);
  const columns = getColumns(fields, onEdit, onDelete);

  const filteredItems = items.filter(notDeleted).map((row, index) => ({
    ...row,
    id: index,
  }));

  return (
    <Table
      columns={columns}
      data={filteredItems}
      exportCSV={false}
      isSelectable={true}
      isRowSelectable={false}
      selected={selected}
      setSelected={setSelected}
      deleteSelected={(values) => {
        onDelete(values);
        setSelected([]);
      }}
    />
  );
};

export default ListItems;
